import { render, staticRenderFns } from "./yongyao-result.vue?vue&type=template&id=60659c8a&"
import script from "./yongyao-result.vue?vue&type=script&lang=ts&"
export * from "./yongyao-result.vue?vue&type=script&lang=ts&"
import style0 from "./yongyao-result.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports